import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export const refererInterceptor: HttpInterceptorFn = (req, next) => {
  if (environment.ENV_ACTIVE_PROFILE === environment.ON_CUSTOMIDP) {

    const clonedRequest = req.clone({
      setHeaders: {
        'X-Referer': 'GroupSales'
      }
    });

    return next(clonedRequest);
  }

  return next(req);
};
